import { render } from "./BillingInfoFormModal.vue?vue&type=template&id=1868f962&scoped=true&bindings={\"id\":\"props\",\"userId\":\"props\"}"
import script from "./BillingInfoFormModal.vue?vue&type=script&lang=js"
export * from "./BillingInfoFormModal.vue?vue&type=script&lang=js"

import "./BillingInfoFormModal.vue?vue&type=style&index=0&id=1868f962&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1868f962"

export default script